import type { Components } from '@mui/material'

export const OmuiDetailTooltip: NonNullable<Components['OmuiDetailTooltip']> = {
  defaultProps: {
    placement: 'right',
  },
  styleOverrides: {
    root: ({ theme }) => ({
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.palette.futureTheme.bg.surface.elevated,
      border: `${theme.futureTheme.strokeWidth.strong} solid ${theme.palette.futureTheme.border.subtle}`,
      borderRadius: theme.shape['futureTheme.radius-md'],
      boxShadow: theme.futureTheme.shadows.md,
      minWidth: 260,
      maxWidth: 360,
      color: theme.palette.futureTheme.text.default,
      textAlign: 'left',
    }),
    header: ({ theme }) => ({
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
      padding: theme.spacing(4),
    }),
    title: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    body: ({ theme }) => ({
      padding: theme.spacing(4),
    }),
    footer: ({ theme }) => ({
      padding: theme.spacing(4),
    }),
  },
}
